



















































import { Component, Vue } from 'vue-property-decorator'
import { Message } from 'element-ui'
import { SyncWechatAdUnitList, QueryWechatAdUnitList, QueryWechatAdRewardConfig, SaveWechatAdRewardConfig } from '@/api'

interface WechatAdUnitRow {
  adUnitName?: string
  adUnitId: string
  adSlot?: string
  configured?: boolean
}

interface WechatAdRewardForm {
  adUnitId: string
  enabled: boolean
  contributionQty: number
  energyQty: number
  mungBeanQty: number
  pointsQty: number
  activityQty: number
  dailyLimit: number
  ladderJson: string
  note: string
}

interface AdLadderState {
  enabled: boolean
  step: number
  increasePercent: number
  maxPercent: number
}

@Component({})
export default class WechatAdReward extends Vue {
  private tableData: WechatAdUnitRow[] = []
  private dialogVisible = false
  private form: WechatAdRewardForm = {
    adUnitId: '',
    enabled: true,
    contributionQty: 0,
    energyQty: 0,
    mungBeanQty: 0,
    pointsQty: 0,
    activityQty: 0,
    dailyLimit: 0,
    ladderJson: '',
    note: '',
  }
  private ladder: AdLadderState = {
    enabled: false,
    step: 5,
    increasePercent: 0,
    maxPercent: 0,
  }

  public created(): void {
    this.load()
  }

  private async sync(): Promise<void> {
    await SyncWechatAdUnitList()
    Message.success('同步成功')
    this.load()
  }

  private async load(): Promise<void> {
    const list = await QueryWechatAdUnitList()
    this.tableData = (list as WechatAdUnitRow[]) || []
  }

  private async openEdit(row: WechatAdUnitRow): Promise<void> {
    this.form = {
      adUnitId: row.adUnitId,
      enabled: true,
      contributionQty: 0,
      energyQty: 0,
      mungBeanQty: 0,
      pointsQty: 0,
      activityQty: 0,
      dailyLimit: 0,
      ladderJson: '',
      note: '',
    }
    this.ladder = {
      enabled: false,
      step: 5,
      increasePercent: 0,
      maxPercent: 0,
    }
    const cfg = await QueryWechatAdRewardConfig({ adUnitId: row.adUnitId })
    if (cfg) {
      this.form = { ...this.form, ...(cfg as Partial<WechatAdRewardForm>) }
    }
    this.loadLadderFromJson(this.form.ladderJson)
    this.dialogVisible = true
  }

  private async save(): Promise<void> {
    const ladderJson = this.buildLadderJson()
    await SaveWechatAdRewardConfig({ ...this.form, ladderJson })
    Message.success('保存成功')
    this.dialogVisible = false
    this.load()
  }

  private loadLadderFromJson(json: string): void {
    if (!json) return
    try {
      const o = JSON.parse(json) as Record<string, unknown>
      const step = Number(o.step || 0)
      const inc = Number(o.increasePercent || 0)
      const max = Number(o.maxPercent || 0)
      if (step > 0 && inc >= 0) {
        this.ladder.enabled = true
        this.ladder.step = step
        this.ladder.increasePercent = inc
        this.ladder.maxPercent = max >= 0 ? max : 0
      }
    } catch {
      // 忽略非 JSON/格式异常
    }
  }

  private buildLadderJson(): string {
    if (!this.ladder.enabled) return ''
    const step = Number(this.ladder.step || 0)
    const inc = Number(this.ladder.increasePercent || 0)
    const max = Number(this.ladder.maxPercent || 0)
    if (step <= 0 || inc <= 0) return ''
    const o: Record<string, number> = { step, increasePercent: inc }
    if (max > 0) o.maxPercent = max
    return JSON.stringify(o)
  }
}
